import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { TrButton } from '@skytech/ui/Table/TrButton'
import { FLAGS_BY_COUNTRY_ID } from '@skytech/utils'
import GlobeIcon from 'mdi-react/GlobeIcon'
import PinIcon from 'mdi-react/PinIcon'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import type { Address } from '@/modules/admin/resources'

export const AddressListItem: FC<
  {
    searchFilter: string
    onAddressEdit: () => void
  } & Address
> = ({ searchFilter, onAddressEdit, ...addressItem }) => {
  const translate = useTranslation()

  const countryName = `${FLAGS_BY_COUNTRY_ID[addressItem.countryId]}  ${addressItem.countryName}`

  return (
    <TrButton onClick={onAddressEdit}>
      <Td>
        <Highlight pattern={searchFilter} text={addressItem.address} />
      </Td>

      <Td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={addressItem.city} />
      </Td>

      <Td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={addressItem.zip} />
      </Td>

      <Td className="hidden whitespace-pre md:table-cell">
        <Highlight pattern={searchFilter} text={countryName || ' - '} />
      </Td>

      <Td>
        <div className="flex items-center gap-x-2">
          <Highlight
            pattern={searchFilter}
            text={addressItem.isGlobal ? translate('Global') : translate('Local')}
          />

          {addressItem.isGlobal ? (
            <GlobeIcon className="h-4 w-4 fill-gray-500" />
          ) : (
            <PinIcon className="h-4 w-4 fill-gray-500" />
          )}
        </div>
        <div className="text-sm text-gray-400">
          <Highlight pattern={searchFilter} text={addressItem.customerName} />
        </div>
      </Td>
    </TrButton>
  )
}
